import React, { useState, useEffect, useRef } from 'react'

import { MediaAudioLUFSAnalyser } from './lufs_analyser'

import './AudioLevelIndicator.scss'

interface AudioLevelIndicatorProps {
  audioTrack?: MediaStreamTrack
  enabled?: boolean
}

const AudioLevelIndicator = ({
  audioTrack,
  enabled = true,
}: AudioLevelIndicatorProps) => {
  const [audioLevel, setAudioLevel] = useState(0)
  const lufsAnalyser = useRef<MediaAudioLUFSAnalyser>(
    new MediaAudioLUFSAnalyser()
  )

  useEffect(() => {
    if (audioTrack) {
      lufsAnalyser.current.setStream(new MediaStream([audioTrack]))
      lufsAnalyser.current.updateEvery(setAudioLevel, 50)
    } else {
      setAudioLevel(0)
      return undefined
    }
    return lufsAnalyser.current.cleanAll
  }, [audioTrack])

  useEffect(() => {
    if (enabled) {
      lufsAnalyser.current.unpause()
    } else {
      lufsAnalyser.current.pause()
      lufsAnalyser.current.cancelUpdates()
      setAudioLevel(0)
    }
  }, [enabled])

  return (
    <meter
      className="audio-level-indicator"
      min={0}
      max={1}
      low={0.01}
      high={0.66}
      optimum={audioLevel > 0.95 ? 0 : 0.5}
      value={enabled ? audioLevel : 0}
    />
  )
}

export { AudioLevelIndicator }
